import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
export var EmptyState = function (_a) {
    var icon = _a.icon, heading = _a.heading, description = _a.description, actionLabel = _a.actionLabel, actionTo = _a.actionTo;
    return (_jsxs(Box, { sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            py: 6,
            px: 3,
        }, children: [_jsx(Box, { sx: {
                    bgcolor: "primary.main",
                    borderRadius: "50%",
                    width: 64,
                    height: 64,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                    "& .MuiSvgIcon-root": {
                        fontSize: 32,
                        color: "secondary.main",
                    },
                }, children: icon }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: heading }), description && (_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { maxWidth: 320 }, children: description })), actionLabel && actionTo && (_jsx(Button, { variant: "contained", color: "primary", component: Link, to: actionTo, sx: { mt: 3 }, children: actionLabel }))] }));
};
